import {
  CompanyManagementPermission,
  SeriesLabelManagementPermission,
  UserManagementPermission,
} from '@auth/permissionsEnum'

/**
 * Permanent Account Manager deletes. Use exact token scopes only.
 * Do not use hasPermission() — resource:all would let IAM/IQM delete today.
 * Grant these scopes on the Superuser role to restore delete.
 */
export function canHardDeleteUsers(tokenPermissions: readonly string[]): boolean {
  return tokenPermissions.includes(UserManagementPermission.HARD_DELETE_USER)
}

export function canHardDeleteCompanies(tokenPermissions: readonly string[]): boolean {
  return tokenPermissions.includes(CompanyManagementPermission.HARD_DELETE_COMPANY)
}

export function canHardDeleteSeriesLabels(tokenPermissions: readonly string[]): boolean {
  return tokenPermissions.includes(SeriesLabelManagementPermission.HARD_DELETE_SERIES_LABEL)
}
